/* ==========================================================
   JOAN'S — DESKTOP STICKY MENU

   The large masthead remains completely untouched.

   Once the existing Chalk navigation reaches the top of the
   browser, it becomes fixed.

   A placeholder keeps its original space in the document so
   there is no page jump.

   Mobile is deliberately excluded.
   ========================================================== */

(() => {

  const desktopQuery =
    window.matchMedia('(min-width: 750px)');

  let nav = null;
  let marker = null;
  let ticking = false;



  function findElements() {

    nav =
      document.querySelector(
        '#header-component .header__row--bottom'
      );

    if (!nav) {
      return false;
    }


    /*
      Create a zero-height marker immediately before the
      navigation.

      When the menu becomes fixed, this marker takes over
      the menu's normal height so the page does not jump.
    */

    marker =
      document.querySelector(
        '.joans-desktop-nav-marker'
      );


    if (!marker) {

      marker =
        document.createElement('div');

      marker.className =
        'joans-desktop-nav-marker';

      marker.setAttribute(
        'aria-hidden',
        'true'
      );


      nav.parentNode.insertBefore(
        marker,
        nav
      );

    }


    return true;
  }



  function releaseNav() {

    if (!nav || !marker) {
      return;
    }


    nav.classList.remove(
      'joans-desktop-nav--fixed'
    );


    marker.style.height = '0px';

  }



  function fixNav() {

    if (!nav || !marker) {
      return;
    }


    /*
      Measure the real Joan's navigation height.
      Currently around 48px, but do not hard-code it.
    */

    const navHeight =
      Math.round(nav.getBoundingClientRect().height);


    marker.style.height =
      `${navHeight}px`;


    nav.classList.add(
      'joans-desktop-nav--fixed'
    );

  }



  function updateNav() {

    ticking = false;


    if (!nav || !marker) {
      return;
    }


    /*
      Never run this behaviour on mobile.
      Mobile uses Joan's separate shop rail.
    */

    if (!desktopQuery.matches) {

      releaseNav();

      return;
    }


    /*
      The marker remains in the menu's original position.

      Once it reaches the top of the viewport, pin the
      existing navigation there.
    */

    const markerTop =
      marker.getBoundingClientRect().top;


    if (markerTop <= 0) {

      fixNav();

    } else {

      releaseNav();

    }

  }



  function requestUpdate() {

    if (ticking) {
      return;
    }


    ticking = true;


    window.requestAnimationFrame(
      updateNav
    );

  }



  function initialise() {

    if (!findElements()) {
      return;
    }


    updateNav();


    /*
      Horizon can use .page-wrapper as its desktop scroll
      container, so listen there as well as on window.
    */

    const pageWrapper =
      document.querySelector('.page-wrapper');


    window.addEventListener(
      'scroll',
      requestUpdate,
      { passive: true }
    );


    if (pageWrapper) {

      pageWrapper.addEventListener(
        'scroll',
        requestUpdate,
        { passive: true }
      );

    }


    window.addEventListener(
      'resize',
      requestUpdate,
      { passive: true }
    );


    if (
      typeof desktopQuery.addEventListener ===
      'function'
    ) {

      desktopQuery.addEventListener(
        'change',
        requestUpdate
      );

    }

  }



  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initialise
    );

  } else {

    initialise();

  }

})();